// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {OfficialslandingModuleLayout} from 'app_components/modules/admin/landings/officialslanding'
import PermissionService from 'app_services/secure/permission/permissionService'
import LandingService from 'app_services/admin/landings/landingService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
import { ILanding } from 'app_types/admin/landings/landingTypes'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IOfficialslandingModuleProps {}
interface IOfficialslandingModuleState {
  landingInfo: ILanding | null
  status: null | 'loading' | 'error'
  loadingForm: null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class OfficialslandingModule extends Component<IOfficialslandingModuleProps, IOfficialslandingModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private landingService: LandingService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IOfficialslandingModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      landingInfo: null,
      loadingForm: null
    }

    this.permission = new PermissionService(this.moduleName)
    this.landingService = new LandingService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchLandingData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchLandingData = async () => {
    this.setState({ status: 'loading' })

    let httpParams: any = {
      slug: 'officials'
    }

    let landing: ILanding | null = null

    const landingResponse = await this.landingService.fetchLandingData(httpParams)

    if (landingResponse) {
      landing = landingResponse
    }

    this.setState({
      landingInfo: landing,
      status: null
    })
  }

  onHandleGeneralInfoSubmit = async (formData: any) => {
    this.setState({loadingForm: 'loading'})

    const landingResponse = await this.landingService.saveGeneralInfo(
      {...formData, slug: 'officials'},
      (this.state.landingInfo && this.state.landingInfo.landing?._id) ? `update/${this.state.landingInfo.landing._id}` : 'create'
    )

    this.setState({loadingForm: null})

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )
    }
  }

  onHandleArticleSubmit = async (formData: any) => {
    this.setState({loadingForm: 'loading'})

    const landingResponse = await this.landingService.saveArticle(
      {...formData.article, slug: 'officials'},
    )

    this.setState({loadingForm: null})

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )

      await this.fetchLandingData()
    }
  }

  onHandleSchedulingSubmit = async (data: any) => {
    if (data.status === 'success') {
      await this.fetchLandingData()
    }
  }

  onHandleTrainingRemove = async (data: any) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('modules.teacher_landing_form.training.delete_alert.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('modules.teacher_landing_form.training.delete_alert.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          this.setState({loadingForm: 'loading'})

          const remove = await this.landingService.removeTraining('teacher', data)

          this.setState({loadingForm: null})

          if (remove) {
            let screen_notification_label = 'components.screen_notifications.delete'

            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
              },
              {
                position: 'top',
              }
            )

            await this.fetchLandingData()
          }
        }
      })
    }
  }

  onHandleTrainingSubmit = async (data: any) => {
    if (data.status === 'success') {
      await this.fetchLandingData()
    }
  }

  render() {
    return(
      <OfficialslandingModuleLayout
        {...this.props}
        landingInfo={this.state.landingInfo}
        loadingForm={this.state.loadingForm}
        permission={this.permission}
        onHandleArticleSubmit={this.permission.check('permission:landings_officials_article', this.onHandleArticleSubmit)}
        onHandleTrainingSubmit={this.permission.check('permission:landings_officials_training', this.onHandleTrainingSubmit)}
        onHandleSchedulingSubmit={this.permission.check('permission:landings_officials_scheduling', this.onHandleSchedulingSubmit)}
        onHandleGeneralInfoSubmit={this.permission.check('permission:landings_officials_general_info', this.onHandleGeneralInfoSubmit)}
        onHandleTrainingRemove={this.permission.check('permission:landings_officials_training', this.onHandleTrainingRemove)}
      />
    )
  }
}

export default connect(mapStatesToProps)(OfficialslandingModule)
